module.exports = __webpack_public_path__ + "static/media/gal-7.6085a127.jpeg";